// @ts-nocheck
import * as $ from 'jquery';
import { CompanyPayingConfiguration } from './Models/CompanyPayingConfiguration';
import { Cart } from './Models/Cart';
import { EmployeeSection } from './EmployeeSection';
import { AddDepartmentToCartRequest, AddToCartRequest } from './Models/AddToCartRequest';
import { SelectedSection } from './SelectedSection';
import { LineItemType } from './Models/LineItemType';
import { CompanyPayingService } from './Models/CompanyPayingService';
import { IHasServices } from './Models/IHasServices';
import { NotificationType } from 'Common/NotificationManager';
import Mediator from 'Common/Mediator';

export class CompanyPayingApplication {
    public currentCart: Cart;
    private currentContainer: JQuery;
    private configuration: CompanyPayingConfiguration;
    private employeeSection: EmployeeSection;
    private selectedSection: SelectedSection;
    private checkoutButton: JQuery;
    private pickEmployeesArea: JQuery;
    private choosenEmployeesArea: JQuery;
    private backButton: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new CompanyPayingConfiguration(container);
        this.currentCart = new Cart();
        this.checkoutButton = $('#SaveButton');
        this.pickEmployeesArea = $('.pick-employees');
        this.choosenEmployeesArea = $('.choosen-employees');
        this.backButton = $('#BackButton');
        this.employeeSection =
            new EmployeeSection(container,
                this.configuration.employeesUrl,
                this.addToCart.bind(this),
                this.addDepartmentToCart.bind(this),
                this.updateSelectedList.bind(this),
                this.runCheckout.bind(this));
        this.selectedSection =
            new SelectedSection(container,
                this.emptyCart.bind(this),
                this.removeEmployeeFromCart.bind(this),
                this.removeDepartmentFromCart.bind(this),
                this.changeCartItem.bind(this));
        this.initialize();
    }

    public checkout(evt: JQueryEventObject) {
        let application = this;
        $.ajax({
            url: this.configuration.checkoutUrl,
            data: this.currentCart,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                Mediator.instance.publish('notification:show', data.Message, NotificationType.Success, true);
                application.emptyCart();
                application.employeeSection.searchEmployees();
            },
            error: function (data) {
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }
                Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
            }
        });
    }

    addToCart(request: AddToCartRequest) {
        this.selectedSection.addToCart(this.currentCart, request);
    }

    addDepartmentToCart(request: AddDepartmentToCartRequest) {
        this.selectedSection.addDepartmentToCart(this.currentCart, request);
    }

    runCheckout() {
        this.checkout(null);
    }

    emptyCart() {
        this.currentCart = new Cart();
        this.updateSelectedList();
        this.pickEmployeesArea.show();
        this.choosenEmployeesArea.hide();
    }

    removeEmployeeFromCart(employeeId: string) {
        let existingIndex = this.currentCart.employees.findIndex(x => x.id === employeeId);

        if (existingIndex >= 0) {
            this.currentCart.employees.splice(existingIndex, 1);
            this.updateSelectedList();
        }

        if (this.currentCart.employees.length === 0) {
            this.emptyCart();
        }
    }

    changeCartItem(id: string, type: LineItemType, service: CompanyPayingService, value: boolean) {
        let item = this.currentCart.employees[this.findEmployeeIndex(id)] as IHasServices;

        switch (service) {
        case CompanyPayingService.TicketApp:
            item.hasTicketApp = value;
            break;
        }
    }

    findEmployeeIndex(employeeId: string) {
        return this.currentCart.employees.findIndex(x => x.id === employeeId);
    }

    findDepartmentIndex(departmentId: string) {
        return this.currentCart.departments.findIndex(x => x.departmentId === departmentId);
    }

    removeDepartmentFromCart(departmentId: string) {
        let existingIndex = this.currentCart.departments.findIndex(x => x.departmentId === departmentId);

        if (existingIndex >= 0) {
            this.currentCart.departments.splice(existingIndex, 1);
            this.updateSelectedList();
        }
    }

    updateSelectedList(): void {
        this.selectedSection.updateList(this.currentCart);
    }

    back(): void {
        this.emptyCart();
    }

    private initialize() {
        this.checkoutButton.on('click', (evt) => this.checkout(evt));
        this.backButton.on('click', () => this.back());
    }
}
